import React from "react";
import {
  FirstAidKit, Scales, Hammer, Storefront, Factory, House, Calculator, Church, HandHeart, Briefcase,
} from "@phosphor-icons/react";

const INDUSTRIES = [
  { icon: FirstAidKit, label: "Medical Practices" },
  { icon: Scales,      label: "Law Firms" },
  { icon: Hammer,      label: "Construction Companies" },
  { icon: Storefront,  label: "Retail Stores" },
  { icon: Factory,     label: "Manufacturing" },
  { icon: House,       label: "Real Estate Offices" },
  { icon: Calculator,  label: "Accounting Firms" },
  { icon: Church,      label: "Churches" },
  { icon: HandHeart,   label: "Nonprofits" },
  { icon: Briefcase,   label: "Professional Services" },
];

export default function Industries() {
  return (
    <section
      data-testid="industries-section"
      className="bg-white py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-sm font-semibold uppercase tracking-widest text-blue-600">
            Industries
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900">
            Industries we support.
          </h2>
          <p className="mt-4 text-zinc-600 text-[15px]">
            Compliance-aware, vertical-specific IT support — we&rsquo;ve worked with these and more.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
          {INDUSTRIES.map(({ icon: Icon, label }, i) => (
            <div
              key={label}
              data-testid={`industry-${i}`}
              className="group flex flex-col items-start gap-3 p-5 rounded-2xl border border-zinc-200 bg-zinc-50 hover:bg-white hover:border-blue-300 hover:shadow-md transition-all"
            >
              <div className="h-10 w-10 rounded-lg bg-blue-600/10 text-blue-600 grid place-items-center group-hover:bg-blue-600 group-hover:text-white transition-colors">
                <Icon size={20} weight="duotone" />
              </div>
              <span className="text-sm font-semibold text-zinc-800 leading-snug">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
